import Lottie from 'lottie-react';

import confettiForCompletedAppointments from '../jsons/confetti-for-completed-appointments.json';

const ConfettiForCompletedAppointments = props => {
  return <Lottie loop={false} animationData={confettiForCompletedAppointments} {...props} />;
};

export default ConfettiForCompletedAppointments;
